export default {
	title: "Web3",
	rule: "Opis zasad",
	safe: "Bezpieczeństwo środków",
	balance: {
		total: "Kwota całkowita",
		yesterday: "Wczorajsze zyski",
		cumulatively: "Zyski łączne",
		in: "Kwota wpłacona",
		out: "Kwota wypłacona",
		available: "Dostępne środki"
	},
	actions: {
		in: "Wpłata",
		out: "Wypłata"
	},
	type: ["Wszystkie", "Wpłata", "Wypłata", "Zyski"],
	TransactionPassword: "Hasło transakcji",
	Amount: "Kwota",
	date: "Data"
};
